"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderItem = void 0;
require("react");
const constants_1 = require("../../constants");
require("../../core");
const renderText_1 = require("./renderText");
const renderItem = (field = 'name', emptyValue = constants_1.EMPTY_TEXT.dash) => (item) => renderText_1.renderText(item === null || item === void 0 ? void 0 : item[field], emptyValue);
exports.renderItem = renderItem;
//# sourceMappingURL=renderItem.js.map